export class Animateur {
    static jsonMap = {
        id: 'id',
        nom: 'nom',
        prenom: 'prenom'
    };

    id: number;
    nom: string;
    prenom: string;

    nomComplet: string;
}
